import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import configService from '../services/configService';

const BillingRedirect = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    
    if (!user) {
      // Redirect to login with return URL
      navigate('/login?redirect=/billing');
      return;
    }

    // User is authenticated, redirect to Stripe billing portal
    const redirectToBilling = async () => {
      try {
        const data = await configService.createBillingPortalSession();
        window.location.href = data.url; // Redirect to Stripe portal
      } catch (error) {
        console.error('Billing portal error:', error);
        navigate('/dashboard');
      }
    };

    redirectToBilling();
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting to billing portal...</p>
      </div>
    </div>
  );
};

export default BillingRedirect;